export default __webpack_public_path__ + "static/media/divider.b62a6075.svg";